import { Injectable, inject } from '@angular/core';
import { FloatingPanelService } from '@shared/floating-panel/floating-panel.service';
import { loadHdChartGlobalSettings } from '../../chart/bodygraph/chart-tabs/hd-chart-global-settings';
import { HdIChingAccessService } from '../hd-iching-access.service';
import { HD_ICHING_GUIDE_PANEL_KEY, HdIChingGuidePanelComponent } from './hd-iching-guide-panel.component';

/**
 * Opent de gids van de Classic I Ching-raadpleging als paneel. Zelfde
 * dock-/dialoogkeuze als `HdIChingPanelService` (globale
 * `gateInfoOpenBehavior`-setting). Het paneel laadt de methode-content zelf in
 * de content-taal, dus een taalwissel werkt ook in een al open gids. No-op
 * zonder toegang.
 */
@Injectable({ providedIn: 'root' })
export class HdIChingGuidePanelService {
  private readonly floatingPanels = inject(FloatingPanelService);
  private readonly access = inject(HdIChingAccessService);

  open(origin?: { x: number; y: number }): void {
    if (!this.access.classicVisible()) {
      return;
    }
    // De gids opent enkel vanaf de raadpleegpagina: de bewaarde setting volstaat (geen live-sync nodig).
    const behavior = loadHdChartGlobalSettings().gateInfoOpenBehavior;
    const docked = behavior === 'full-docked-keep' || behavior === 'full-docked-autoclose';

    this.floatingPanels.openOrFocus<HdIChingGuidePanelComponent, undefined>({
      key: HD_ICHING_GUIDE_PANEL_KEY,
      component: HdIChingGuidePanelComponent,
      data: undefined,
      dockTab: { label: '?', icon: 'circle-question' },
      dockZone: 'full',
      openInitiallyDocked: docked,
      redockOnReopen: docked,
      startPosition: origin != null ? { preferred: origin, hint: 'prefer-right-of-anchor' } : 'center',
    });
  }
}
